import Auth from '../auth';
import CookieUtils from '../../utils/cookies';
import { HTTPError } from 'utils/HTTPError';

export const fetchHandler = async (url, options, hasRetriedAfterRefresh = false) => {
  try {
    const response = await fetch(url, options);

    if (!response.ok) {
      throw new HTTPError(response);
    }

    return response;
  } catch (e) {
    /**
     * Added for forward compatibility, as we are aiming to return 401 errors when authenticated
     * requests to the Auth service fail due to expired access tokens.
     *
     * See https://springhealth.atlassian.net/browse/CORE-3169
     *
     * Retry only once: if the API rejects the new token too (e.g. a service that doesn't accept
     * Auth0 tokens yet), refreshing again can't help and would loop forever.
     */
    if (e.response?.status === 401 && !hasRetriedAfterRefresh) {
      await Auth.refreshAccessToken();

      return fetchHandler(
        url,
        {
          ...options,
          headers: {
            ...options.headers,
            ...CookieUtils.getAuthorizationHeader(),
          },
        },
        true
      );
    } else {
      throw e;
    }
  }
};

export default fetchHandler;
